// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bjlnO","index":"styles_index__CGKMF"};